import { GET_PRODUCTS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_PRODUCTS:
            return action.payload;
        default:
            return state;
    }
}
